import { f7 } from 'framework7-vue';
import { autobind } from "@/decorators/autobind";
import ViewController from "@/interfaces/ViewController";
import AppController from "@/targets/main/components/App/ts/AppController";
import ServiceAccount from "@/services/v2/data/service-account/ServiceAccount";
import ServiceOperations from "@/services/v2/data/service-operations/ServiceOperations";

export default class PaymentsViewController implements ViewController {
    private static _instance: PaymentsViewController | null = null;

    public static of() {
        if (PaymentsViewController._instance === null) {
            PaymentsViewController._instance = new PaymentsViewController();
        }

        return PaymentsViewController._instance;
    }

    @autobind
    public async updateAccountData() {
        try {
            const routesWithUpdateAccount = ['/withdrawal', '/payment', '/settings'];
            if (routesWithUpdateAccount.includes(f7.views.current.router.previousRoute.path)) {
                await this.updateMyAccount();
            }
        } catch (e) {
            await AppController.getInstance().logout();
            throw e;
        }
    }

    @autobind
    public async updateMyPayments() {
        await ServiceOperations.of().fetchOperations({ refresh: true });
    }

    @autobind
    public async updateMyAccount() {
        await ServiceAccount.of().fetchAccount();
    }

    public destructor() {
        PaymentsViewController._instance = null;
    }
}
